import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import axios from "axios";
import moment from "moment";
import Pagination from "react-js-pagination";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";

import { KioskResStatus } from "./component/styled/resStatus";
import { Container } from "./component/styled/common";

import KioskHeader from "./component/common/kioskHeader";
import KioskFooter from "./component/common/kioskFooter";
import KioskTable from "./component/common/kioskTable";
import KioskList from "./component/common/kioskList";
import DetailsUseInquiry from "./component/kioskResStatus/detailsUseInquiry";

import { useDisableScroll } from "../../../hooks/useDisableScroll";
import { checkKioskCond } from "../dashboard/component/function/dashboard";

const KioskRreservationStatusPage = () => {
  useDisableScroll();

  const navigate = useNavigate();

  const isTablet = useMediaQuery({ query: "(max-width:1050px)" });
  const [data, setData] = useState([]);
  const [searched, setSearched] = useState("");
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [selected, setSelected] = useState([]);
  const [dateRange, setDateRange] = useState({
    startDate: null,
    endDate: null,
    key: "selection",
  });
  const [openCalendar, setOpenCalendar] = useState(false);
  const [loading, setLoading] = useState(false);

  const user = useSelector((state) => state?.user?.data[0]);
  const company = useSelector((state) => state?.company?.data);

  useEffect(() => {
    if (!checkKioskCond(company)) {
      toast.error("접근 권한이 없습니다.", { toastId: "no-access" });
      navigate("/mypage");
      return;
    }

    getEnableStorage(page - 1);
  }, []);

  const getEnableStorage = async (current = 0, flag = { text: true, date: true }) => {
    if (loading) return;

    setLoading(true);

    const url = "/api/reserve-history";
    const body = { point: "sungsim", page: current, size: isTablet ? 6 : 10 };

    if (flag.text && searched) {
      body.searchQuery = searched;
    }

    const formatDate = (date) => moment(date).format("YYYY-MM-DD");

    if (flag.date && dateRange.startDate && dateRange.endDate) {
      body.reservationStartDay = formatDate(dateRange.startDate);
      body.reservationEndDay = formatDate(dateRange.endDate);
    }

    try {
      const res = await axios.post(url, body);

      if (res.status === 200) {
        setTotal(res.data.totalElements);
        setData(res.data.content);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const getEnableStorageDetail = async (id) => {
    const url = "/api/reserve-user-detail";
    const body = { id, point: "sungsim" };
    const res = await axios.post(url, body);

    if (res.status === 200) {
      return res.data;
    }
  };

  const handleModalOpen = async (item) => {
    console.log(item);
    const detail = await getEnableStorageDetail(item.id);
    setSelected(detail);

    if (detail && detail.length) {
      setOpenModal(true);
    }
  };

  const handleOpenCalendar = () => {
    setOpenCalendar(!openCalendar);
  };

  const handleDateClick = (ranges) => {
    setDateRange({
      startDate: ranges["selection"].startDate,
      endDate: ranges["selection"].endDate,
      key: ranges["selection"].key,
    });
  };

  const handleSearch = (flag = false) => {
    if (page !== 1) {
      setPage(1);
    }
    getEnableStorage(0, { text: flag ? false : true, date: true });
  };

  const handleResetDate = async () => {
    setDateRange({ startDate: null, endDate: null, key: "selection" });
    setOpenCalendar(false);

    await getEnableStorage(0, { text: true, date: false });
  };

  const changePage = async (page) => {
    setPage(page);
    await getEnableStorage(page - 1);
  };

  return (
    <Container>
      <KioskResStatus>
        <KioskHeader
          title={"이용내역조회"}
          handleSearch={handleSearch}
          searched={searched}
          setSearched={setSearched}
          dateRange={dateRange}
          openCalendar={openCalendar}
          handleOpenCalendar={handleOpenCalendar}
          handleDateClick={handleDateClick}
          handleResetDate={handleResetDate}
        />
        <div className="content">
          {isTablet ? (
            <KioskList data={data} type="resStatus" handleModalOpen={handleModalOpen} />
          ) : (
            <KioskTable data={data} type="resStatus" handleModalOpen={handleModalOpen} />
          )}
        </div>
        <Pagination
          innerClass="pagination sungsim"
          activePage={page}
          itemsCountPerPage={isTablet ? 6 : 10}
          totalItemsCount={total}
          pageRangeDisplayed={isTablet ? 5 : 10}
          prevPageText={"‹"}
          nextPageText={"›"}
          onChange={changePage}
        />
        <KioskFooter />
        {openModal && <DetailsUseInquiry selected={selected} setOpenModal={setOpenModal} />}
      </KioskResStatus>
    </Container>
  );
};

export default KioskRreservationStatusPage;
